import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { CapacitorSafeService } from '../iframe-in-app/capacitor-safe.service';

@Injectable({
  providedIn: 'root'
})
export class AppPlatformService {

  constructor(private platform: Platform,
    private capacitorSafe: CapacitorSafeService,
  ) { }

  isAppPlatform(): boolean {
    return !this.capacitorSafe.isInIframe() && this.platform.is('capacitor') && ( this.platform.is('ios') || this.platform.is('android') );
  }

  isIosHibridApp(): boolean {
    return !this.capacitorSafe.isInIframe() && this.platform.is('capacitor') &&  this.platform.is('ios');
  }

  isAndroidHibridApp(): boolean {
    return !this.capacitorSafe.isInIframe() && this.platform.is('capacitor') && this.platform.is('android');
  }

  isMobileWeb(): boolean {
    return this.platform.is('mobileweb');
  }
}
